import request from '@/utils/request'

// 产品相关 API
export const sysApi = {
  sendEmail(mailData) {
    return request({
      url: '/api/email/sender',
      data: mailData,
      method: 'post'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js